import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, inject } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ConstructAPI } from "src/app/API/constructAPI";
import { RestApiService } from "src/app/API/restapi";
import { ALERT_TYPE } from "src/app/constants";
import { SharedService } from "src/app/Shared/shared-service.service";
import { Account } from "src/model/account.model";
import { Customer } from "src/model/customer.model";
import { Profile } from "src/model/profile.model";
import { AddSimpanComponent } from "../add-simpan/add-simpan.component";
import { ViewReserveGroupsComponent } from "../view-reserve-groups/view-reserve-groups.component";

interface ReserveDistribution {
  companyId: number;
  companyName: string;
  amount: number;
  isMain: boolean;
}

@Component({
    selector: "app-add-reserve-group",
    templateUrl: "./add-reserve-group.component.html",
    styleUrls: ["./add-reserve-group.component.scss"],
    providers: [DatePipe],
    standalone: false
})
export class AddReserveGroupComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private datepipe = inject(DatePipe);

  @Input() sharedProfileId: number;
  @Input() selectedCustomer: Customer;
  @Input() selectedProfile: Profile;
  @Input() isModal = true;

  isContraAccount = false;
  reserveDistributionList: ReserveDistribution[] = [];

  totalReserve = 0;

  disabledSubmit = false;
  companyBankAccountList: Account[] = [];
  cashAccountList: Account[] = [];

  selectedAccountId: number;
  simpanDate: Date;
  loggedInCompanyId: number;

  @Input() selectedProfileId: number;
  @Output() passEntry = new EventEmitter<any>();

  ngOnInit(): void {
    this.getSharedProfileDetails();
    this.loggedInCompanyId = Number(sessionStorage.getItem("companyId"));
    this.getAllAccountsOfCompany(this.loggedInCompanyId);
  }

  async checkNull() {
    let errorStr = "";

    const validCheckIn = await this.validateCheckInBeforeSubmit();

    if (validCheckIn) {
      this.reserveDistributionList.forEach((distribution) => {
        if (distribution.amount == undefined || distribution.amount == null)
          errorStr +=
            "The payment amount for company " +
            distribution.companyName +
            " cannot leave empty!\n";
      });
    }
    else {
      errorStr += "Cannot submit reserve group on " + this.datepipe.transform(this.simpanDate, "dd-MM-yyyy") + ", please check your verify date!"
    }

    return errorStr;
  }

  checkValidity() {
    if (this.isContraAccount == false) {
      const totalMainOutAmount = this.calculateTotalMainDistribution();
      if (this.selectedAccountId == undefined || this.simpanDate == undefined)
        this.sharedService.openAlert(
          "Please select account and date",
          ALERT_TYPE.DANGER
        );
      else if (this.calculateTotalDistribution() == 0) {
        this.sharedService.openAlert(
          "Please key in each company payment",
          ALERT_TYPE.DANGER
        );
      } else if (this.totalReserve + totalMainOutAmount < 0) {
        this.sharedService.openAlert(
          "Main company out simpan amount is more than total simpan customer have, please check amount!",
          ALERT_TYPE.DANGER
        );
      } else {
        const main = this.reserveDistributionList.findIndex(
          (distribution) => distribution.isMain == true
        );
        this.reserveDistributionList[main].amount = totalMainOutAmount;

        this.submit();
      }
    } else this.submit();
  }

  async submit() {
    this.disabledSubmit = true;
    const errorStr = await this.checkNull();

    const data = {
      isContra: this.isContraAccount,
      distribution: this.reserveDistributionList.filter(rg => rg.amount != 0),
    };
    if (errorStr == "") {
      const xhr = this.restApi.postRequest(
        this.constructApi.getAddProfileReserveGroup(this.sharedProfileId),
        data
      );
      xhr.onreadystatechange = () => {
        if (xhr.readyState == 4) {
          this.disabledSubmit = false;
          if (xhr.status == 200) {
            const json = JSON.parse(xhr.responseText);

            //check if logged in company have any distributed amount, if not no need to accept
            const ownDistribution = this.reserveDistributionList.find(rg => rg.companyId == this.loggedInCompanyId);
            if (ownDistribution.amount != 0 && ownDistribution != undefined)
              this.acceptReserveGroup(Number(json.id));
            else
              this.openViewReserveGroupModal(Number(json.id));
          }
          else this.sharedService.openErrorMessage(xhr);
        }
      };
    } else {
      this.disabledSubmit = false;
      this.sharedService.openAlert(errorStr, ALERT_TYPE.DANGER);
    }
  }

  acceptReserveGroup(reserveGroupId: number) {
    const isoDate = new Date(Number(this.simpanDate)).toISOString();

    const remark =
      this.isContraAccount == true
        ? "RETURN TO HQ= "
        : "TRANSFER TO SHARED BRANCHES= ";
    const data = {
      remark:
        remark +
        this.selectedCustomer.Name +
        "(" +
        this.selectedCustomer.ICNumberWithDash +
        ")",
      accountId: Number(this.selectedAccountId),
      dateCreated: isoDate,
    };
    const xhr = this.restApi.postRequest(
      this.constructApi.getAcceptReserveGroup(reserveGroupId),
      data
    );
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        if (xhr.status == 200) {
          this.sharedService.openAlert(
            "Successfully added simpan distribution!",
            ALERT_TYPE.SUCCESS
          );
          // window.location.reload();
          this.activeModal.close();

          const addedSimpanIndex = this.reserveDistributionList.findIndex(
            (distribution) => distribution.companyId == this.loggedInCompanyId
          );

          this.passEntry.emit(
            this.reserveDistributionList[addedSimpanIndex].amount
          );
          // this.openUploadReserveGroupDocModal(reserveGroupId);
        } else this.sharedService.openErrorMessage(xhr);

        this.openViewReserveGroupModal(reserveGroupId);
      }
    };
  }

  openViewReserveGroupModal(reserveGroupId: number) {
    const modalRef = this.sharedService.openModal(ViewReserveGroupsComponent);

    modalRef.componentInstance.reserveGroupId = reserveGroupId;
  }

  topUpSimpan() {
    const modalRef = this.sharedService.openModal(AddSimpanComponent);
    modalRef.componentInstance.isModal = true;
    modalRef.componentInstance.selectedProfileID = this.sharedProfileId;
    modalRef.componentInstance.selectedProfile = this.selectedProfile;
    modalRef.componentInstance.selectedCustomer = this.selectedCustomer;

    modalRef.componentInstance.passEntry.subscribe((entry) => {
      const addedSimpan = entry;

      this.totalReserve += addedSimpan;
    });
  }

  reset() {
    this.activeModal.close();
  }

  addSimpan() {
    this.disabledSubmit = true;
    const isoSimpanDate = new Date(Number(this.simpanDate)).toISOString();

    let reserveAmount = 0;
    this.reserveDistributionList.forEach((distribution) => {
      reserveAmount += distribution.amount;
    });

    const data = {
      reserve: reserveAmount,
      accountId: Number(this.selectedAccountId),
      dateCreated: isoSimpanDate,
      remark: "RESERVE GROUP",
    };

    const xhr = this.restApi.postRequest(
      this.constructApi.getAddReserve(this.sharedProfileId),
      data
    );
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        if (xhr.status == 200) {
          //deduct amount of distribution to other companies from main company distribution
          const index = this.reserveDistributionList.findIndex(
            (distribution) =>
              Number(distribution.companyId) == Number(this.loggedInCompanyId)
          );
          if (index != -1) {
            this.reserveDistributionList[index].amount =
              this.reserveDistributionList[index].amount - reserveAmount;
            this.submit();
          }
        } else this.sharedService.openErrorMessage(xhr);
      }
    };
  }

  getAllAccountsOfCompany(companyId: number) {
    const loggedInUsername = sessionStorage.getItem("username");
    const xhttp = this.restApi.getRequest(
      this.constructApi.getAccountsOfCompany(companyId)
    );
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse(xhttp.responseText);

        jsonArray.forEach((json) => {
          const account = new Account(
            json.id,
            json.number,
            json.name,
            json.holderName,
            json.balance,
            json.companyId,
            json.username
          );

          if (account.Username == undefined)
            this.companyBankAccountList.push(account);
          else {
            if (this.sharedService.isStaff()) {
              if (account.Username == loggedInUsername)
                this.cashAccountList.push(account);
            } else {
              this.cashAccountList.push(account);
            }
          }
        });
      }
    };
  }

  getSharedProfileDetails() {
    this.reserveDistributionList = [];

    const xhttp = this.restApi.getRequest(
      this.constructApi.getSharedProfile(this.sharedProfileId)
    );
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const json = JSON.parse(xhttp.responseText);
        const profilesArr = json.profiles;

        profilesArr.forEach((profileJson) => {
          const distribution = {
            companyId: profileJson.companyId,
            companyName: profileJson.companyCode,
            amount: 0,
            isMain: profileJson.profileId == this.sharedProfileId,
          };
          this.reserveDistributionList.push(distribution);

          this.totalReserve += profileJson.reserve;
        });
      }
    };
  }

  calculateTotalMainDistribution() {
    let total = 0;
    this.reserveDistributionList.forEach((distribution) => {
      const amount = distribution.amount == undefined ? 0 : distribution.amount;
      total -= amount;
    });

    return total;
  }

  calculateTotalDistribution() {
    let total = 0;
    this.reserveDistributionList.forEach((distribution) => {
      const amount = distribution.amount == undefined ? 0 : distribution.amount;
      total += amount;
    });

    return total;
  }

  getCompanyLatestCheckIn(companyId: number) {
    return new Promise<Date>(resolve => {
      const xhttp = this.restApi.getRequest(this.constructApi.getCompaniesLatestCheckIns(companyId))
      xhttp.onreadystatechange = () => {
        if (xhttp.readyState == 4 && xhttp.status == 200) {
          const jsonArray = JSON.parse((xhttp.responseText));
          jsonArray.forEach(json => {
            resolve(new Date(json.date));
          });
        }
      }
    });
  }

  async validateCheckInBeforeSubmit() {
    const latestCheckInDate = await this.getCompanyLatestCheckIn(this.loggedInCompanyId)

    return this.sharedService.isAcctCheckedInBeforeAction(this.simpanDate, latestCheckInDate);
  }
}
